import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="hidden md:block bg-trendyol-dark text-white mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
        <div className="border-t border-gray-700 pt-4 flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="text-xs text-gray-400">© 2024. Tüm hakları saklıdır.</p>
          <div className="flex gap-4 text-xs text-gray-400">
            <Link to="#" className="hover:text-trendyol-orange transition-colors">Kullanım Koşulları</Link>
            <Link to="#" className="hover:text-trendyol-orange transition-colors">Gizlilik Politikası</Link>
            <Link to="#" className="hover:text-trendyol-orange transition-colors">Çerez Politikası</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
